import { Component, Input, OnInit } from '@angular/core';
import { Routes } from 'src/app/routes/routes';
import { ApiService } from 'src/app/services/api.service';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'voucher-download-btn',
  templateUrl: './voucher-download-btn.component.html',
  styleUrls: ['./voucher-download-btn.component.scss']
})
export class VoucherDownloadBtnComponent implements OnInit {

  @Input("id") id                       = null;
  @Input("paymentLink") paymentLink:any = false;
  public loader                         = false;
  @Input("template") template:any       = 1;
  
  constructor(
    private api: ApiService,
    private modal: ModalService
  ){}

  /***
   * 
   * Send 
   * 
   * 
   **/
  send(){

    try{


      //var link = document.createElement('a');  
      //link.href = Routes.sale.order.order.voucher.download+"/"+this.id;
      let url = Routes.sale.order.order.voucher.download+"/"+this.id;
      window.open(url,"_blank");
      //link.download = "voucher.pdf";
      //link.click();
      return false;
      this.loader = true;

      if(this.paymentLink == false || this.paymentLink == "false"){

        this.api.sale().order().voucher().download(this.id).subscribe((response:any) => {

          this.loader = false;

          if(response.status == 1){

            var link = document.createElement('a');  
            link.href = Routes.sale.order.order.voucher.download+"/"+response.file;
            link.download = "voucher.pdf";
            link.click();

          }else{

            let error:any   = this.api.formatError(response);
            this.modal.open(error.message);

          }

        },(response:any) => {

          this.loader = false;
          let error:any  = this.api.formatError(response);
          this.modal.open(error.message);

        });
      
      }else{

        this.api.paymentLink().order().voucher().download(this.id).subscribe((response:any) => {

          this.loader = false; 

          if(response.status == 1){

            var link = document.createElement('a');  
            link.href = Routes.paymentLink.order.url+"/voucher/download/"+response.file;
            link.download = "voucher.pdf";
            link.click();

          }else{

            let error:any   = this.api.formatError(response);
            this.modal.open(error.message);

          }

        },(response:any) => {

          this.loader = false;
          let error:any   = this.api.formatError(response);
          this.modal.open(error.message);

        });

      }
      
    }catch(e:any){
      
      this.loader = false;
      this.modal.open(e.message);

    }

  }
  /***
   * 
   * Init
   * 
   */
  ngOnInit():void{}

}
